import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
	FormGroup,
	FormBuilder,
	Validators,
	AbstractControl
} from '@angular/forms';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { ShareDataService } from '../share-data.service';

import * as moment from 'moment';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';

@Component({
	selector: 'app-add-trainer-form',
	templateUrl: './add-trainer.component.html',
	styleUrls: ['./add-trainer.component.css']
})
export class AddTrainerComponent implements OnInit {
	errorMsg: string;
	userInfo: any;
	checkList: any = {
		trainerDeclaratioin: true
	};
	currentUserRole: any;
	public currentStep = 1;
	currentUserDetails: any = {};
	public firstTimeLoad = true;
	public firstTimePreferenceLoad = true;
	// public firstTimeContactLoad = true;
	public applicantForm: FormGroup;
	emailPattern = '^[A-Za-z0-9][A-Za-z.0-9]{1,}[@][A-Za-z0-9]{1,}[.](([A-Za-z]{2,3})|([A-Za-z0-9]{2,3}[.][A-Za-z]{2}))$';
	@Output() submitData = new EventEmitter<any>();
	@Output() personalInfoData = new EventEmitter<any>();
	@Output() contactDetailsData = new EventEmitter<any>();
	@Output() educationAndWorkDetailsData = new EventEmitter<any>();
	@Output() preferencesData = new EventEmitter<any>();
	@Output() previous = new  EventEmitter<any>();
//    aadharVerify:any = {
// 		 isAadhaarVerified:false,
//        aadharNumber:''
// 	 }
	constructor(
		private fb: FormBuilder,
		private shareDataService: ShareDataService,
		private currentUserService: CurrentUserService
	) {}

	ngOnInit() {
		this.createForm();
	//    console.log(this.aadharVerify)
		this._getCurrentUser();
		if (this.currentUserRole === 'Candidate') {
				console.log('loggedInUser');
			this.getCurrentUserAdditionalInfo();
			// this.applicantForm	.get('contactDetails')	.get('phone').setValidators([]);
			// this.applicantForm	.get('contactDetails')	.get('email')	.setValidators([]);
		}
	}

	_getCurrentUser() {
		this.currentUserService.getCurrentUser().subscribe(loggedInUser => {
			// this.userInfo = JSON.parse(localStorage.getItem('loginUserData'));
			this.currentUserRole = loggedInUser.role;
			console.log(loggedInUser, 'userInfo');
			console.log(loggedInUser.role, 'userInforole');
		});
	}

	/*formValid() {
		console.log(this.checkList.trainerDeclaratioin);
		return (
			(this.currentStep === 1 &&
				!this.applicantForm.get('personalDetails').valid) ||
			(this.currentStep === 2 &&
				!this.applicantForm.get('contactDetails').valid) ||
			(this.currentStep === 3 &&
				!this.applicantForm.get('educationAndWorkDetails').valid) ||
			(this.currentStep === 4 &&
				!this.applicantForm.get('preferences').valid) ||

		);
	}*/

	getCurrentUserAdditionalInfo() {
		this.currentUserService.getCurrentUser().subscribe(
			res => {
				this.currentUserDetails = res;
				// this.currentUserDetails = JSON.parse(localStorage.getItem('loginUserData'));
				console.log(this.currentUserDetails, 'this.currentUserDetails');
				// console.log(this.currentUserDetails.personalDetails, 'personal');
				if (this.currentUserRole === 'Candidate') {
					console.log(this.currentUserDetails.personalDetails.dob);
					if (this.currentUserDetails.personalDetails.dob) {
						this.currentUserDetails.personalDetails.dob = moment(
						this.currentUserDetails.personalDetails.dob
					).format('DD/MM/YYYY');
					}
					this.applicantForm
						.get('personalDetails')
						.patchValue(this.currentUserDetails.personalDetails);
					if (this.currentUserDetails.contactDetails.communicationAddress == null){
						this.currentUserDetails.contactDetails.communicationAddress = {};
					}
					this.applicantForm
						.get('contactDetails')
						.patchValue(this.currentUserDetails.contactDetails);
					// this.applicantForm
					// 	.get('educationalDetails')
					// 	.patchValue(this.currentUserDetails.educationalDetails);
					// this.applicantForm
					// 	.get('coursePreferences')
					// 	.patchValue(this.currentUserDetails.coursePreferences);
					console.log(this.applicantForm, 'this.applicantForm');
				}
			},
			error => {
				console.log(`Error in fetching data. ${error}`);
			}
		);
	}

	createForm() {
		this.applicantForm = this.fb.group({
			personalDetails: this.fb.group({
				firstName: [
					'',
					[
						Validators.required,
						Validators.pattern('^[a-zA-Z][a-zA-Z .\'-]+$')
					]
				],
				namePrefix: ['', [ Validators.required]],
				/*	middleName: ['', [Validators.pattern('^[a-zA-Z]+$')]],
				lastName: [
					'',
					[
						Validators.maxLength(30),
						Validators.pattern('^[a-zA-Z]+$')
					]
				],*/
				aadharNumber: [
					null,
					[
					 	// Validators.required,

					]
				],
				aadharDoc: [
					'',
					[
					// 	Validators.required,
						ValidationService.fileTypeValidator(
							'pdf',
							'jpeg',
							'png',
							'jpg'
						),
						ValidationService.fileSizeValidator(5)
					]
				],
				gender: ['', Validators.required],
				guardianName: [
					'',
					[
						Validators.required,
						Validators.maxLength(100),
						Validators.pattern('^[a-zA-Z][a-zA-Z .\']+$')
					]
				],
				relationWithGuardian: ['', [Validators.required]],
				alternateIdType: ['', []],
				alternateIdNumber: [
					null,
					[Validators.pattern('^[a-zA-Z0-9]+$')]
				],
				alternateIdDoc: [
					'',
					[
					ValidationService.fileTypeValidator(
							'pdf',
							'jpeg',
							'png',
							'jpg'
						),
						ValidationService.fileSizeValidator(5)
					]
				],
				dob: ['', [Validators.required]],
				disabilityCategory: [null, []],
				disabilityDoc: [
					'',
					[
						ValidationService.fileSizeValidator(5),
						ValidationService.fileTypeValidator(
							'pdf',
							'jpeg',
							'png',
							'jpg'
						)
					]
				],
				differentlyAbled: ['', [Validators.required]],
				caste: ['', [Validators.required]],
				profilePicture: [
					'',
					[
						Validators.required,
						ValidationService.fileValidator,
						ValidationService.fileSizeValidator(5),
						ValidationService.fileTypeValidator(
							'jpeg',
							'png',
							'jpg'
						),
						,
						ValidationService.fileSizeValidator(5)
					]
				],
				religion: ['', [Validators.required]]
			}),
			contactDetails: this.fb.group({
				phone: [
					null,
					[
						// Validators.required,
						Validators.minLength(10),
						Validators.maxLength(10),
						Validators.pattern('[1-9][0-9]{9}')
					]
				],
				email: ['', [ValidationService.emailValidatorMand]],
				permanentAddress: this.fb.group({
					country: ['India', []],
					countryId: ['91', []],
					address1: [
						'',
						[
							Validators.pattern(
								/^(?=.*[a-zA-Z])[a-zA-Z0-9-/,.#&() \.\s]*$/
							),
							Validators.required
						]
					],
					city: ['', [Validators.required]],
					pinCode: [
						'',
						Validators.compose([
							Validators.required,
							Validators.pattern('^[1-9][0-9]*$'),
							Validators.minLength(6),
							Validators.maxLength(6)
						])
					],
					state: ['', [Validators.required]],
					stateId: [null, []],
					districtDetails: this.fb.group({
						district: ['', [Validators.required]],
						districtId: [null, []],
						subDistrict: ['', [Validators.required]],
						subDistrictId: ['', []],
						parliamentaryConstituency: ['', [Validators.required]]
					})
				}),
				communicationAddress: this.fb.group({
					country: ['India', []],
					countryId: ['91', []],
					address1: [
						'',
						[
							Validators.pattern(
								/^(?=.*[a-zA-Z])[a-zA-Z0-9-/,.#&() \.\s]*$/
							),
							Validators.required
						]
					],
					city: ['', [Validators.required]],
					pinCode: [
						'',
						Validators.compose([
							Validators.required,
							Validators.pattern('^[1-9][0-9]*$'),
							Validators.minLength(6),
							Validators.maxLength(6)
						])
					],
					state: [null, [Validators.required]],
					stateId: [null, []],
					districtDetails: this.fb.group({
						district: [null, [Validators.required]],
						districtId: [null, []],
						subDistrict: [null, [Validators.required]],
						subDistrictId: ['', []],
						parliamentaryConstituency: [null, [Validators.required]]
					})
				})
			}),
			educationalDetails: this.fb.array([]),
			coursePreferences: this.fb.array([]),
			educationAndWorkDetails: this.fb.group({
				educationalDetails: this.fb.array([])
			}),
			preferences: this.fb.group({
				// heardAboutUs: ['', []],
				coursePreferences: this.fb.array([])
			}),
			heardFrom: ['',	[]]
			// declaration: ['']
			// declaration: ['', Validators.required]
		});
	}
	createEducationForm(): FormGroup {
		return this.fb.group({
			name: ['', Validators.required],
			details: [''],
			supportingDocument: [
				null,
				[
					Validators.required,
					ValidationService.fileValidator,
					ValidationService.fileTypeValidator('pdf'),
					ValidationService.fileSizeValidator(5)
				]
			]
		});
	}
	createWorkAndTrainingExperienceForm() {
		return this.fb.group({
			sector: [{ sectorID: '', sector: '' }, [Validators.required]],
			totalExperience: this.fb.group({
				months: [null, [Validators.required]],
				years: [null, [Validators.required]]
			}),
			details: [''],
			supportingDocument: [
				null,
				[
					Validators.required,
					ValidationService.fileValidator,
					ValidationService.fileTypeValidator('pdf'),
					ValidationService.fileSizeValidator(5)
				]
			]
		});
	}
	saveAndContinue() {
		window.scrollTo(0, 0);
		let isFormValid = false;
		let date = this.applicantForm.get('personalDetails').get('dob').value;
						date = Helpers.toDateFromCalendar(date);
						this.applicantForm.get('personalDetails').get('dob').setValue(
							date
							);
		switch (this.currentStep) {
			case 1:
				isFormValid = this.checkValidForm(
					this.applicantForm.get('personalDetails')
				);
				if (isFormValid) {
					if (this.currentUserRole === 'Candidate') {
						let date = this.applicantForm.get('personalDetails').get('dob').value;
						date = Helpers.toDateFromCalendar(date);
						this.applicantForm.get('personalDetails').get('dob').setValue(
							date
							);



					// 	this.applicantForm.get('personalDetails').get('firstName').setValue(this.currentUserDetails.personalDetails	.firstName);
					this.applicantForm.get('contactDetails').get('phone').setValue(this.currentUserDetails.contactDetails.phone	);
						this.applicantForm
							.get('contactDetails')
							.get('email')
							.setValue(
								this.currentUserDetails.contactDetails.email
							);
						this.personalInfoData.emit(this.applicantForm.value);
					}
					this.shareDataService.setData(
						this.applicantForm.get('personalDetails').value
					);
					// this.personalInfoData.emit(this.applicantForm.get('personalDetails').value);
				}
				break;
			case 2:
				console.log(this.applicantForm.get('contactDetails').valid);

				isFormValid = this.checkValidForm(
					this.applicantForm.get('contactDetails')
				);
				if (isFormValid) {
					if (this.currentUserRole === 'Candidate') {
					// 	this.applicantForm.get('contactDetails').get('phone').setValue(this.currentUserDetails.contactDetails.phone
					// 		);
					// 	this.applicantForm
							// .get('contactDetails')
							// .get('email')
						// 	.setValue(
						// 		this.currentUserDetails.contactDetails.email
						// 	);
							console.log(this.applicantForm.value);
							let date = this.applicantForm.get('personalDetails').get('dob').value;
							date = Helpers.toDateFromCalendar(date);
							this.applicantForm.get('personalDetails').get('dob').setValue(
								date
							);
						this.contactDetailsData.emit(this.applicantForm.value);
					}
					this.shareDataService.setData(this.applicantForm.value);

					// this.contactDetailsData.emit(this.applicantForm.get('contactDetails').value);
				}
				break;
			case 3:
				isFormValid = this.checkValidForm(
					this.applicantForm.get('educationAndWorkDetails')
				);
				if (isFormValid) {
					this.applicantForm.value.educationalDetails = this.applicantForm.value.educationAndWorkDetails.educationalDetails;
					if (this.currentUserRole === 'Candidate') {
						console.log(
							this.applicantForm.value.educationalDetails
						);
						let date = this.applicantForm.get('personalDetails').get('dob').value;
						date = Helpers.toDateFromCalendar(date);
						this.applicantForm.get('personalDetails').get('dob').setValue(
							date
							);
						this.educationAndWorkDetailsData.emit(
							this.applicantForm.value
						);
						console.log(this.applicantForm.value);
						// this.educationAndWorkDetailsData.emit(this.applicantForm.get('educationAndWorkDetails').value);
					}
					this.shareDataService.setData(this.applicantForm.value);
				}
				break;
			case 4:
				isFormValid = this.checkValidForm(
					this.applicantForm.get('preferences')
				);
				if (isFormValid) {
					this.applicantForm.value.educationalDetails = this.applicantForm.value.educationAndWorkDetails.educationalDetails;
					this.applicantForm.value.coursePreferences = this.applicantForm.value.preferences.coursePreferences;
					if (this.currentUserRole === 'Candidate') {
						this.preferencesData.emit(this.applicantForm.value);
						// this.preferencesData.emit(this.applicantForm.get('preferences').value);
					}
					let date = this.applicantForm.get('personalDetails').get('dob').value;
						date = Helpers.toDateFromCalendar(date);
						this.applicantForm.get('personalDetails').get('dob').setValue(
							date
							);

					console.log(this.applicantForm.value, 'laststep');
				}
				break;
		}
		if (isFormValid) {
			this.currentStep++;
		} else {
		}
	}
	saveAndDraft() {
		switch (this.currentStep) {
			case 1:
				if (this.currentUserRole === 'Candidate') {
			/*	let date = this.applicantForm.get('personalDetails').get('dob').value;
						date = Helpers.toDateFromCalendar(date);
						this.applicantForm.get('personalDetails').get('dob').setValue(
							date
							);*/



					// 	this.applicantForm.get('personalDetails').get('firstName').setValue(this.currentUserDetails.personalDetails	.firstName);
					this.applicantForm.get('contactDetails').get('phone').setValue(this.currentUserDetails.contactDetails.phone	);
						this.applicantForm
							.get('contactDetails')
							.get('email')
							.setValue(
								this.currentUserDetails.contactDetails.email
							);
					this.personalInfoData.emit(this.applicantForm.value);
				}
				this.shareDataService.setData(
					this.applicantForm.get('personalDetails').value
				);
				break;
			case 2:
				console.log(this.applicantForm.get('contactDetails').valid);
				if (this.currentUserRole === 'Candidate') {
					/*if (this.currentUserDetails.contactDetails.phone === 0) {
						this.applicantForm
						.get('contactDetails')
						.get('phone')
						.setValue(null);
					}
					this.applicantForm
						.get('contactDetails')
						.get('email')
						.setValue(this.currentUserDetails.contactDetails.email);*/
						this.previous.emit(true);
						let date = this.applicantForm.get('personalDetails').get('dob').value;
						date = Helpers.toDateFromCalendar(date);
						this.applicantForm.get('personalDetails').get('dob').setValue(
							date
							);
					this.contactDetailsData.emit(this.applicantForm.value);
				}
				this.shareDataService.setData(this.applicantForm.value);
				break;
			case 3:
				this.applicantForm.value.educationalDetails = this.applicantForm.value.educationAndWorkDetails.educationalDetails;
				if (this.currentUserRole === 'Candidate') {
					console.log(this.applicantForm.value.educationalDetails);
					let date = this.applicantForm.get('personalDetails').get('dob').value;
					date = Helpers.toDateFromCalendar(date);
					this.applicantForm.get('personalDetails').get('dob').setValue(
						date
						);
					this.educationAndWorkDetailsData.emit(
						this.applicantForm.value
					);
					// this.educationAndWorkDetailsData.emit(this.applicantForm.get('educationAndWorkDetails').value);
				}
				this.shareDataService.setData(this.applicantForm.value);
				break;
			case 4:
				this.applicantForm.value.educationalDetails = this.applicantForm.value.educationAndWorkDetails.educationalDetails;
				this.applicantForm.value.coursePreferences = this.applicantForm.value.preferences.coursePreferences;
				console.log(this.applicantForm.value.preferences.coursePreferences);
				if (this.currentUserRole === 'Candidate') {
					let date = this.applicantForm.get('personalDetails').get('dob').value;
					date = Helpers.toDateFromCalendar(date);
					this.applicantForm.get('personalDetails').get('dob').setValue(
						date
						);
					this.preferencesData.emit(this.applicantForm.value);
					// this.preferencesData.emit(this.applicantForm.get('preferences').value);
				}

				this.shareDataService.setData(this.applicantForm.value);
				break;
		}
	}
	checkValidForm(formGroup: AbstractControl) {
		return formGroup.valid;
	}
	goBack() {
		this.getCurrentUserAdditionalInfo();
		this.currentStep--;
		if (this.currentStep === 1) {
			console.log(this.applicantForm.get('personalDetails').value);
			console.log(this.applicantForm.value);
			console.log(
				this.applicantForm.get('personalDetails').get('dob').value
			);

			this.applicantForm
				.get('personalDetails')
				.get('dob')
				.setValue(
					moment(
						this.applicantForm.get('personalDetails').get('dob')
							.value
					).format('DD/MM/YYYY')
				);
		}
	}

	submit() {
		console.log('caled');
		console.log(this.applicantForm.value);
		console.log(this.applicantForm.value.contactDetails.valid);
		if (this.applicantForm.value.contactDetails.phone === 0) {
			this.applicantForm.get('contactDetails').get('phone').setValue(null);
		}
		if (this.applicantForm.valid) {
			console.log('vslid');

			this.applicantForm.value.educationalDetails = this.applicantForm.value.educationAndWorkDetails.educationalDetails;
			this.applicantForm.value.coursePreferences = this.applicantForm.value.preferences.coursePreferences;
					this.applicantForm.value.heardFrom = this.applicantForm.get('heardFrom').value;
			this.shareDataService.setData(this.applicantForm.value);
			this.submitData.emit(this.applicantForm.value);
		} else {
			this.errorMsg = 'Please fill All Mandatory Field';
		}
	}
}
